import { Box, Link } from '@mui/material';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import Utils from '../../../utils/Utils';
import styles from './BlockFullBleedImage.module.css';
import BlockProps from '../../../models/BlockProps';
import BlockFullBleedImageData from './BlockFullBleedImageData';
import ImageSettingsModal from '../../Modals/ImageSettingsModal/ImageSettingsModal';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockData from '../../../models/BlockData';
import CroppedImage from '../../CroppedImage';
import useGetBackground from '../../../hooks/UseGetBackground';
import BackGroundImageModal from '../../Modals/ImageModal/BackGroundImageModal';
import useParallaxScript from '../../../hooks/useParallaxScript';
import config from '../../../config';
import ImageEnlargeModal from '../../Images/ImageEnlargeModal';

interface BlockFullBleedImageProps extends BlockProps {
  blockData: BlockData[]
  showImageModal?: boolean
  onCloseImageModal?: () => void;
}

function BlockFullBleedImage({
  data,
  isEditing,
  isTemplate,
  editHandler,
  blockData,
  showImageModal,
  onCloseImageModal,
}: BlockFullBleedImageProps) {
  const targetModalId = uuid();

  const [props, setProps] = useState<BlockFullBleedImageData>(data.data as BlockFullBleedImageData);

  useEffect(() => {
    setProps(data.data as BlockFullBleedImageData);
  }, [data.data]);

  const elementUuid = uuid();
  useParallaxScript(props.backgroundImage?.settings?.parallaxBool, elementUuid, config.backgroundImage.parallaxEffect);

  return (
    <Box
      id={elementUuid}
      sx={{
        overflow: 'hidden',
        ...useGetBackground(
          props.backgroundImage?.solidColor,
          props.backgroundImage?.value,
          props.backgroundImage?.settings?.scale,
          props.backgroundImage?.settings?.scaleBool,
        ),
        backgroundPosition: 'center 0px',
      }}
    >
      {(isEditing && !isTemplate) && (
        <BackGroundImageModal
          backgroundImage={props.backgroundImage}
          isShowModal={showImageModal}
          onCloseModal={onCloseImageModal}
          handleOnConfirm={(url: BlockComponentImage) => {
            const tempBg = { ...props, backgroundImage: { ...url } };
            setProps(tempBg);
            editHandler(data.id, tempBg);
          }}
        />
      )}
      <Box
        className={styles.imageBoxContainer}
        sx={
          isEditing ? Utils.hoverBorder(true, {
            height: '100%',
            position: 'static',
          }) : {
            height: '100%',
            position: 'static',
          }
        }
      >
        <ImageSettingsModal
          isEditing={isEditing}
          blockData={blockData}
          image={props.url}
          disabled={isTemplate || !isEditing}
          onConfirm={(newImage: BlockComponentImage) => {
            props.url = newImage;
            editHandler(data.id, props);
          }}
        >
          {(!isEditing) ? (
            <Link
              style={{ cursor: props?.url?.link?.linkData?.url ? 'pointer' : 'default' }}
              target={props?.url?.link?.linkData?.openType}
              href={props?.url?.link?.linkData?.url || undefined}
              sx={{
                width: '100%',
                height: '100%',
              }}
              rel="noreferrer"
            >
              <CroppedImage
                image={props.url}
                isEditing={isEditing}
                settings={props.url.settings}
                targetModalId={targetModalId}
              />
            </Link>
          ) : (
            <CroppedImage
              image={props.url}
              isEditing={isEditing}
              settings={props.url.settings}
              targetModalId={targetModalId}
            />
          )}
        </ImageSettingsModal>
      </Box>

      <ImageEnlargeModal
        images={[props.url]}
        targetModalId={targetModalId}
      />
    </Box>
  );
}

export default BlockFullBleedImage;
